import React from 'react';
import MuiTabs from '@mui/material/Tabs';
import MuiTab from '@mui/material/Tab';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { fontWeight } from 'presentations/views/styles';

interface Props {
  value: any;
  indicatorColor?: 'primary';
  specifyIndicatorColor?: string;
  textColor?: 'primary';
  onChange?: any;
  className?: string;
  tabs: {
    label?: React.ReactNode;
    icon?: string;
    isDisabled?: boolean;
  }[];
  isDisabled?: boolean;
  variant?: 'scrollable' | 'fullWidth' | 'standard';
  scrollButtons?: boolean | 'auto';
  isCentered?: boolean;
}

export default function Component(props: Props) {
  return (
    <Tabs
      value={props.value}
      className={props.className}
      indicatorColor={props.indicatorColor || 'primary'}
      textColor={props.textColor}
      onChange={props.onChange}
      variant={props.variant || 'scrollable'}
      scrollButtons={props.scrollButtons || false}
      disabled={props.isDisabled}
      centered={props.isCentered}
      specifyindicatorcolor={props.specifyIndicatorColor}
    >
      {props.tabs.map((tab, index) => (
        <Tab
          key={index}
          value={index}
          label={tab.label}
          icon={tab.icon}
          disabled={tab.isDisabled}
          onClick={(e) => props.onChange(e, index)}
        />
      ))}
    </Tabs>
  );
}

const Tabs = styled(MuiTabs)<{
  specifyindicatorcolor?: string;
}>`
  .MuiTabs-indicator {
    transition: none;
    ${({ specifyindicatorcolor }) =>
      specifyindicatorcolor &&
      css`
        background-color: ${specifyindicatorcolor};
      `}
  }
`;
const Tab = styled(MuiTab)`
  font-weight: ${fontWeight('bold')};
  min-width: 100px;
  opacity: 1 !important;
  &.Mui-disabled {
    opacity: 0.5 !important;
  }
`;
